(() => {
  const WRAPPER_SELECTOR = '.shopify-section[id*="maison_category_overlay"]';
  const GRID_SELECTOR = '.maison-category-overlay__grid';
  const CARD_SELECTOR = '.maison-category-overlay-card';

  function findWrappers(scope = document) {
    const wrappers = new Set();

    if (scope.matches?.(WRAPPER_SELECTOR)) wrappers.add(scope);
    scope.querySelectorAll?.(WRAPPER_SELECTOR).forEach(el => wrappers.add(el));

    // Fallback: discover by actual grid, then climb to Shopify section wrapper.
    if (scope.matches?.(GRID_SELECTOR)) {
      wrappers.add(scope.closest('.shopify-section') || scope.parentElement);
    }
    scope.querySelectorAll?.(GRID_SELECTOR).forEach(grid => {
      wrappers.add(grid.closest('.shopify-section') || grid.parentElement);
    });

    return [...wrappers].filter(Boolean);
  }

  function prepare(wrapper) {
    if (wrapper.dataset.seelenhauchCatMotionV4 === '1') return;
    const grid = wrapper.querySelector(GRID_SELECTOR);
    if (!grid) return;

    const cards = [...grid.querySelectorAll(CARD_SELECTOR)];
    if (!cards.length) return;

    wrapper.dataset.seelenhauchCatMotionV4 = '1';

    cards.forEach((card, index) => {
      card.style.setProperty('--seelenhauch-cat-delay', `${index * 95}ms`);
    });

    // Apply hidden state first.
    wrapper.classList.add('seelenhauch-cat-motion-ready');

    // Force the browser to paint the initial state before revealing.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const reveal = () => wrapper.classList.add('seelenhauch-cat-motion-visible');

        if (!('IntersectionObserver' in window)) {
          setTimeout(reveal, 100);
          return;
        }

        const rect = wrapper.getBoundingClientRect();
        const alreadyVisible =
          rect.top < window.innerHeight * 0.9 &&
          rect.bottom > window.innerHeight * 0.05;

        if (alreadyVisible) {
          // Still animate on initial page load.
          setTimeout(reveal, 120);
          return;
        }

        const observer = new IntersectionObserver((entries, obs) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            reveal();
            obs.unobserve(entry.target);
          }
        }, {
          threshold: 0.12,
          rootMargin: '0px 0px -8% 0px'
        });

        observer.observe(wrapper);
      });
    });
  }

  function init(scope = document) {
    findWrappers(scope).forEach(prepare);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  // Shopify Theme Editor compatibility.
  document.addEventListener('shopify:section:load', e => init(e.target));

  // Small test/replay helper.
  window.seelenhauchCategoryMotion = {
    replay() {
      findWrappers().forEach(wrapper => {
        wrapper.classList.remove('seelenhauch-cat-motion-visible');
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            setTimeout(() => wrapper.classList.add('seelenhauch-cat-motion-visible'), 80);
          });
        });
      });
    },
    status() {
      return findWrappers().map(wrapper => ({
        id: wrapper.id,
        ready: wrapper.classList.contains('seelenhauch-cat-motion-ready'),
        visible: wrapper.classList.contains('seelenhauch-cat-motion-visible'),
        cards: wrapper.querySelectorAll(CARD_SELECTOR).length
      }));
    }
  };
})();
